import { render } from "./ViewRecieptModal.vue?vue&type=template&id=f8cf7c46"
import script from "./ViewRecieptModal.vue?vue&type=script&lang=js"
export * from "./ViewRecieptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__